import React from 'react';

const html = require('./home');

const template = { __html: html };

const HomePage = () => {
	return (
		<div className='screen-share w-100'>
			{/* eslint-disable-next-line react/no-danger */}
			<span dangerouslySetInnerHTML={template} />
		</div>
	);
};
export default HomePage;
